/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import _isNull from 'lodash/isNull';
import _isEmpty from 'lodash/isEmpty';
import { bool, number, string } from 'prop-types';
import { Typography, useBreakpoint } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import {
  useDimensionsStore,
  useProductInfoStore,
} from '../../../store';
import { useDesignStore } from '../../../store/design/context';

const MAX_PRODUCT_HEIGHT = 15;

const ArrowSVG = ({ productHeight }) => {
  const arrowPosition = (productHeight - 70);

  return (
    <div
      style={{ top: `${arrowPosition}px` }}
      className="initial-arrow"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="352" height="66" viewBox="0 0 352 66" fill="none">
        <path d="M0 62L57.5131 56.943L24.3771 9.66369L0 62ZM352 62C355.646 58.5785 355.644 58.5762 355.642 58.5738C355.641 58.5727 355.638 58.57 355.636 58.5678C355.632 58.5633 355.627 58.558 355.621 58.5518C355.609 58.5395 355.594 58.5237 355.576 58.5045C355.539 58.4662 355.489 58.4144 355.426 58.3495C355.3 58.2197 355.12 58.0376 354.887 57.8067C354.421 57.3448 353.739 56.6877 352.839 55.8634C351.039 54.2148 348.363 51.8969 344.781 49.1344C337.617 43.6094 326.827 36.3051 312.166 29.0221C282.821 14.4449 238.062 3.8147e-06 176 3.8147e-06V10C236.447 10 279.689 24.0551 307.717 37.9779C321.742 44.9449 331.981 51.8907 338.674 57.0531C342.021 59.6343 344.482 61.7696 346.085 63.2381C346.887 63.9724 347.475 64.5399 347.852 64.9131C348.04 65.0996 348.176 65.2376 348.259 65.3235C348.301 65.3664 348.33 65.3964 348.346 65.4128C348.354 65.4211 348.358 65.426 348.36 65.4274C348.36 65.4281 348.36 65.428 348.359 65.427C348.359 65.4265 348.357 65.4252 348.357 65.4249C348.356 65.4233 348.354 65.4215 352 62ZM176 3.8147e-06C110.049 3.8147e-06 63.6423 16.3117 34.5095 31.7549L39.1931 40.5902C66.9659 25.868 111.773 10 176 10V3.8147e-06Z" fill="url(#paint0_linear_827_250672)" />
        <defs>
          <linearGradient id="paint0_linear_827_250672" x1="0" y1="4.99998" x2="330.295" y2="4.99998" gradientUnits="userSpaceOnUse">
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0.2" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

ArrowSVG.propTypes = {
  productHeight: number,
};

ArrowSVG.defaultProps = {
  productHeight: 0,
};

const SecondaryArrowSVG = ({ hasProducts }) => (
  <div className="secondary-arrow">
    <svg xmlns="http://www.w3.org/2000/svg" width="125px" height={hasProducts ? '28vh' : '24vh'} viewBox="0 0 18 76" fill="none">
      <path d="M14 76L17.204 58.9784L0.860901 64.7144L14 76ZM14 1C12.7218 0.214959 12.7214 0.21564 12.721 0.216365C12.7208 0.216664 12.7203 0.217434 12.7199 0.218034C12.7192 0.219234 12.7184 0.220609 12.7174 0.22216C12.7155 0.225261 12.7132 0.229064 12.7105 0.23357C12.7051 0.242581 12.698 0.254406 12.6893 0.269054C12.672 0.298352 12.6482 0.338948 12.6186 0.390944C12.5592 0.494936 12.4761 0.644518 12.3727 0.840496C12.1658 1.23247 11.8776 1.80994 11.5356 2.57936C10.8515 4.11837 9.95245 6.4243 9.05794 9.54851C7.26849 15.7984 5.5 25.3126 5.5 38.5L8.5 38.5C8.5 25.5845 10.2315 16.3486 11.9421 10.3743C12.7975 7.38636 13.6485 5.21159 14.2769 3.79794C14.5912 3.09102 14.8498 2.57417 15.0258 2.2409C15.1137 2.07426 15.181 1.95349 15.2242 1.87779C15.2458 1.83994 15.2614 1.81335 15.2705 1.79793C15.2751 1.79022 15.278 1.78529 15.2793 1.78315C15.28 1.78208 15.2802 1.7817 15.28 1.78202C15.2799 1.78218 15.2797 1.78251 15.2794 1.78301C15.2793 1.78326 15.2789 1.78377 15.2789 1.7839C15.2785 1.78445 15.2782 1.78504 14 1ZM5.5 38.5C5.5 49.2181 6.6682 57.5102 8.06675 63.5961L10.9905 62.9242C9.64401 57.0647 8.5 48.9982 8.5 38.5L5.5 38.5Z" fill="url(#paint0_linear_4214_12221)" />
      <defs>
        <linearGradient id="paint0_linear_4214_12221" x1="6.99999" y1="76" x2="6.99999" y2="-15.3793" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  </div>
);

SecondaryArrowSVG.propTypes = {
  hasProducts: bool.isRequired
};

const MobileView = ({ hasSelectedProduct, useAltPipView }) => {
  const typographyPadding = classNames({
    'sui-pl-4': useAltPipView
  });

  const containerStyles = classNames('sui-flex sui-flex-row', {
    'sui-justify-between': useAltPipView,
    'sui-justify-evenly': !useAltPipView,
  });

  return (
    <div className="sui-flex sui-flex-col empty-stack-mobile">
      {!useAltPipView && (
        <span className="sui-pr-1 sui-pt-4">
          <Typography variant="h3" color="brand">Fully Customize Your Storage</Typography>
        </span>
      )}
      <div className={containerStyles}>
        <div style={{ opacity: hasSelectedProduct ? 0.5 : 1 }}>
          <Typography align="left" variant="body-lg" color="inverse" weight="bold">1. Tap an</Typography>
          <div className="sui-ml-6">
            <Typography align="left" variant="body-lg" color="inverse" weight="bold">item</Typography>
            <Typography align="left" variant="body-lg" color="inverse" weight="bold">below to</Typography>
            <Typography align="left" variant="body-lg" color="inverse" weight="bold">select it</Typography>
          </div>
        </div>
        <div style={{ opacity: hasSelectedProduct ? 1 : 0.5 }}>
          <div className={typographyPadding}>
            <Typography align="left" variant="body-lg" color="inverse" weight="bold">2. Tap a</Typography>
          </div>
          <div className="sui-ml-6">
            <Typography align="left" variant="body-lg" color="inverse" weight="bold">Drop Zone</Typography>
            <Typography align="left" variant="body-lg" color="inverse" weight="bold">to add to</Typography>
            <Typography align="left" variant="body-lg" color="inverse" weight="bold">your stack</Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

MobileView.propTypes = {
  hasSelectedProduct: bool,
  useAltPipView: bool,
};

MobileView.defaultProps = {
  hasSelectedProduct: false,
  useAltPipView: false,
};

const DesktopView = ({ isFromPip, displayName }) => {
  const desktopViewStyles = classNames('sui-flex sui-flex-col sui-flex-wrap sui-justify-end', {
    'empty-desktop-view': isFromPip,
    'sui-h-1/2': !isFromPip,
  });
  return (
    <div className={desktopViewStyles}>
      <Typography variant="h3" color="brand" weight="display">Drag-and-drop</Typography>
      <Typography variant="h3" color="inverse" weight="display">items here to start building your</Typography>
      <Typography variant="h3" color="brand" weight="display">Custom {`${displayName}`}</Typography>
    </div>
  );
};

DesktopView.propTypes = {
  isFromPip: bool,
  displayName: string.isRequired
};

DesktopView.defaultProps = {
  isFromPip: false,
};

function getElementTopPosition(element) {
  const containerRect = element.parentNode.parentNode.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  const topPosition = elementRect.top - containerRect.top;
  return topPosition;
}

const EmptyStack = () => {
  const products = useDesignStore((state) => state.design.products);
  const isFromPip = useDesignStore((state) => state.design.isFromPip);
  const skuDimensions = useDimensionsStore((state) => state.skuDimensions);
  const selectedProduct = useDesignStore((state) => state.design.selectedProduct);
  const productInfo = useProductInfoStore((state) => state.productInfo);

  const matches = useBreakpoint(
    'lg',
    { current: true });
  const [topPosition, setTopPosition] = useState();

  const isDesktop = matches.greater;
  const hasSelectedProduct = !_isNull(selectedProduct);

  useEffect(() => {
    if (!isFromPip) return;
    const element = document.querySelector('.stack-container');

    setTopPosition(getElementTopPosition(element));

  }, [isFromPip, matches.current, Math.round(window.devicePixelRatio * 100)]);

  const altPipView = () => {
    return isFromPip
        && !_isEmpty(products)
        && !_isEmpty(skuDimensions)
        && skuDimensions[products[0].Sku].height > MAX_PRODUCT_HEIGHT;
  };

  const useAltPipView = altPipView();

  return (
    <div className="empty-stack-container">
      {isDesktop ? (
        <>
          <DesktopView isFromPip={isFromPip} displayName={productInfo?.displayName} />
          {!selectedProduct ? <ArrowSVG productHeight={Number(topPosition)} /> : <div />}
        </>
      ) : <MobileView useAltPipView={useAltPipView} hasSelectedProduct={hasSelectedProduct} />}
      {!selectedProduct ? <SecondaryArrowSVG hasProducts={!_isEmpty(products.length)} /> : <div />}
    </div>
  );
};

export default EmptyStack;
